 <template>
  <div class="row col-md-12">
    <div class="col-md-3">
      <h1>{{ $tc('trabalho', 2) | capitalize }} <small>({{trabalhos_filtrados.length}}/{{trabalhos.length}})</small></h1>
      <div>
        <input
          type="text"
          class="form-control"
          :placeholder="$t('placeholder_pesquise_por_titulo')"
          @blur="blurPesquisa()"
          v-model="pesquisa">
      </div>
    </div>
    <div class="col-md-9">
      <div v-if="trabalhos_filtrados.length > 0">
        <anais-trabalho-row :trabalho_id="t.id" v-for="t in trabalhos_pagina" :key="t.id"></anais-trabalho-row>
        <div class="paginas">
          <div class="pagina-btn" v-if="pagina > 1" @click="pagina = 1">&laquo;</div>
          <div class="pagina-btn" v-if="pagina > 1" @click="pagina--">&lt;</div>
          <div class="pagina-btn" :class="{'pagina-selected': pagina == i}" v-for="i in qtd_paginas" v-if="Math.abs(pagina - i) <= max_pag_diff" @click="pagina = i">{{i}}</div>
          <div class="pagina-btn" v-if="pagina < qtd_paginas" @click="pagina++">&gt;</div>
          <div class="pagina-btn" v-if="pagina < qtd_paginas" @click="pagina = qtd_paginas">&raquo;</div>
        </div>
      </div>
      <!-- não tenho trabalhos para mostrar -->
      <div v-else>
        <h3>{{ $t('nao_ha_trabalhos_pesquisa') }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import removeAccents from 'remove-accents'
import { i18n } from '@/langs/anais'

export default {
  name: 'anaisTrabalhos',
  props: {},
  components: {},
  data () {
    return {
      // quantidade de páginas
      qtd_paginas: null,
      // quantidade de trabalhos por página
      qtd_trabalhos_pag: 10,
      // pagina atual
      pagina: 1,
      // a verdadeira variável de pesquisa
      pesquisa: '',
    }
  },
  filters: {},
  watch: {
    pesquisa() {
      this.pagina = 1
    },
    '$route.params.pesquisa'() {
      this.changePesquisaFromParam()
    }
  },
  computed: {
    trabalhos_filtrados() {
      // antes de retornar
      // chama essa função
      let ret = (trabalhos) => {
        // muda a quantidade de páginas disponíveis
        // se eu tenho um trabalho sobrando na próxima página
        // preciso adicionar um
        this.qtd_paginas = Math.ceil(trabalhos.length / this.qtd_trabalhos_pag)
        // volta para a página 1
        this.pagina = 1
        return trabalhos
      }

      if(this.pesquisa == '') {
        return ret(this.trabalhos)
      }
      // se na string str
      // contem o this.pesquisa
      // retorna true
      let pesquisa = removeAccents(this.pesquisa.toLowerCase())
      let find = (str) => removeAccents(str.toString().toLowerCase()).indexOf(pesquisa) != -1
      return ret(this.trabalhos.filter(t => {
        let possiveisStrs = [
          t.eixo.nome,
          t.id,
          t.titulo,
          t.autor.nome,
          t.autor.instituicao,
          t.palavras_chaves.map(p => p.palavra_chave).join(' '),
          t.resumo,
        ]
        // adiciona os nomes dos coautores
        t.coautores.forEach(c => {
          possiveisStrs.push(c.nome);
          possiveisStrs.push(c.instituicao);
        })

        // retorna true se alguma das possiveis strings
        // conter a pesquisa
        for(let i=0; i<possiveisStrs.length; i++) {
          let str = possiveisStrs[i];
          if(find(str)) {
            return true
          }
        }
        // nao encontrei
        return false
      }))
    },
    trabalhos_pagina() {
      let start = (this.pagina-1) * this.qtd_trabalhos_pag
      return this.trabalhos_filtrados.slice(start, start + this.qtd_trabalhos_pag)
    },
    trabalho() {
      if(this.$route.params.trabalho_id) {
        let trabalho_id = this.$route.params.trabalho_id
        return this.trabalhos.find(t => t.id == trabalho_id)
      }
      return null
    },
    max_pag_diff() {
      // o máximo de difenreça que uma pagina pode ter
      // se estou na página 1, posso ir até a 5
      // se estou na última, posso voltar 5
      let pagina = this.pagina
      if(pagina < 4) {
        return 5-pagina;
      }
      return 2;
    },

    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos() { return eixos }, autores() { return autores }, palavras_chaves() { return palavras_chaves }, trabalhos() { return trabalhos },
  },
  created: function () {
    this.changePesquisaFromParam()
  },
  mounted: function () {},
  methods: {
    changePesquisaFromParam() {
      let pesquisa = this.$route.params.pesquisa
      this.pesquisa = pesquisa ? pesquisa : ''
    },
    blurPesquisa() {
      this.$router.replace({
        name: 'trabalhos',
        params: {pesquisa: this.pesquisa},
      })
    },
  },
  i18n: i18n
}
</script>

<style type="text/css" scoped>
.paginas {
  text-align: center;
}
.pagina-btn {
  display: inline-block;
  cursor: pointer;
  padding: 10px 16px;
  margin: 0 5px;
  color: black;
}
.pagina-selected {
  text-decoration: underline;
  font-weight: bold;
}
.pagina-btn:hover {
  box-shadow: 0 0 1px red;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// AnaisTrabalhos.vue?022a21a0